/**
 * @generated SignedSource<<c7c9b10aa5064751624cac39e8967f02>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type FeaturedDealStatus = "CLOSED" | "DRAFT" | "PENDING" | "PUBLISHED";
import { FragmentRefs } from "relay-runtime";
export type DealManageMenu_featuredDeal$data = {
  readonly id: string;
  readonly status: FeaturedDealStatus;
  readonly " $fragmentType": "DealManageMenu_featuredDeal";
};
export type DealManageMenu_featuredDeal$key = {
  readonly " $data"?: DealManageMenu_featuredDeal$data;
  readonly " $fragmentSpreads": FragmentRefs<"DealManageMenu_featuredDeal">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DealManageMenu_featuredDeal",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "FeaturedDealNode",
  "abstractKey": null
};

(node as any).hash = "7493f3cf4ab07e885e256f46b076df32";

export default node;
